/*
 * Copyright (c) 2023-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {Util} from "../Utilities.js";

const worker = new Worker(new URL('./WorkerTasks.js', import.meta.url), {type: 'module'})

const handlers = {}

worker.onmessage = function (e) {
    if (!e.data.error) {
        handlers[e.data.key].resolve(e.data.output)
    } else {
        handlers[e.data.key].reject(e.data.msg)
    }
}
worker.onerror = function (e) {
    console.log(e);
}

async function callFunc(type, input) {
    let key = Util.unique.newInternalId()
    return new Promise((resolve, reject) => {
        handlers[key] = {resolve, reject}
        worker.postMessage({key: key, type: type, input: input})
    })
}

const WebWorker = function () {
    function gzip(bodyString) {
        return callFunc("gzip", [bodyString])
    }


    return {gzip: gzip}
}()


export {
    WebWorker
}